import { StringDevUIField } from "./StringDevUIField";

export class StringDevFieldToggle extends StringDevUIField<boolean> {
  private checkbox: HTMLInputElement | null = null;
  private toggle: HTMLDivElement | null = null;

  build(): HTMLElement {
    const row = this.createRow();
    row.appendChild(this.createLabel());

    const toggle = document.createElement("div");
    toggle.setAttribute("data-string-dev-toggle", "");
    toggle.setAttribute("data-checked", String(this.value));

    const knob = document.createElement("div");
    knob.setAttribute("data-string-dev-toggle-knob", "");
    toggle.appendChild(knob);

    const hidden = document.createElement("input");
    hidden.type = "checkbox";
    hidden.checked = this.value;
    hidden.setAttribute("data-string-dev-toggle-input", "");
    this.checkbox = hidden;
    this.toggle = toggle;

    toggle.addEventListener("click", () => {
      const next = !this.value;
      this.value = next;
      hidden.checked = next;
      toggle.setAttribute("data-checked", String(next));
      this.emit(next);
    });

    row.appendChild(hidden);
    row.appendChild(toggle);
    this.root = row;
    return row;
  }

  setValue(value: boolean): void {
    this.value = value;
    if (this.checkbox) this.checkbox.checked = value;
    this.toggle?.setAttribute("data-checked", String(value));
  }
}
